import {
  AfterContentInit,
  Component,
  ContentChildren,
  EventEmitter,
  Host,
  Optional,
  Output,
  QueryList,
} from '@angular/core';
import { TabsComponent } from '../tabs.component';
import { TabOptionComponent } from './tab-option.component';

@Component({
  selector: 'app-tab-options',
  template: `<ng-content></ng-content>`,
  styles: [
    `
      :host {
        display: flex;
        width: 100%;
        align-items: stretch;
      }
    `,
  ],
})
export class TabOptionsComponent implements AfterContentInit {
  constructor(@Optional() @Host() public ownerTabs?: TabsComponent) {}

  @ContentChildren(TabOptionComponent, { descendants: false })
  options!: QueryList<TabOptionComponent>;
  @Output() optionsChange = new EventEmitter<QueryList<TabOptionComponent>>();

  ngAfterContentInit() {
    this.optionsChange.emit(this.options);
    this.options.changes.subscribe(() => this.optionsChange.emit(this.options));
  }
}
